import React from 'react'

import { IconProps } from './types'

const ChevronUp: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    stroke={color}
    {...rest}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M5 15l7-7 7 7"
    />
  </svg>
)
ChevronUp.defaultProps = {
  size: 24,
  color: 'currentColor',
}

export default ChevronUp
